(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky Header */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.parentElement/*document.querySelector('.section-header')*/;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

   hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* PB */
  /* Permanently Opened Submenus in Menu Drawer */
  const permanentlyOpenedDetails = document.querySelectorAll('header .menu-drawer .keep-open');

  if (permanentlyOpenedDetails.length) {
    permanentlyOpenedDetails.forEach((details)=>{
      const detailsSummary = details.querySelector('summary');
      
      details.parentElement.parentElement.classList.add('submenu-open');
      details.parentElement.parentElement.classList.add('keep-submenu-open');

      details.addEventListener('toggle', (event) => {
        event.preventDefault();
        details.open = true;
      });

      detailsSummary.addEventListener('click', (event) => {
        event.preventDefault();
        details.open = true;
      });
    });
  }

  /* Menu Drawer Items with Media */
  const menuItemMediaContent = document.querySelectorAll('header .menu-drawer .menu-drawer__menu-item .media');

  if (menuItemMediaContent.length) {
    menuItemMediaContent.forEach((mediaContent)=>{
      mediaContent.parentElement.parentElement.parentElement.classList.add('media-menu')
    });
  }

  /* Mega Menu Level 1 */
  const megaMenus = document.querySelectorAll('.mega-menu');

  if (megaMenus.length) {
    megaMenus.forEach((megaMenuItem) => {
      var aTiming;

      megaMenuItem.addEventListener("mouseenter", () => {
        if (megaMenuItem.classList.contains('shrinking') || !megaMenuItem.open) {
          clearTimeout(aTiming);
          megaMenuItem.classList.add('expanding');
          megaMenuItem.classList.remove('shrinking');
          document.documentElement.classList.add('overlay-active');
          document.documentElement.classList.add('overlay-visible');
          megaMenuItem.open = true;
          megaMenuItem.querySelector('summary').ariaExpanded = 'true';
          megaMenuItem.classList.remove('expanding');

          if (megaMenuItem.id == 'Details-HeaderMenu-1') {
            let lvl2Item = megaMenuItem.querySelector('#HeaderMenu-mega-menu-item-shop-featured');

            if (lvl2Item) {
              megaMenuItem.classList.add('featured-active');
            }
          }
        }
      });

      megaMenuItem.addEventListener("mouseleave", () => {
        if (megaMenuItem.classList.contains('expanding') || megaMenuItem.open) {
          megaMenuItem.classList.remove('featured-active');
          megaMenuItem.classList.add('shrinking');
          megaMenuItem.classList.remove('expanding');

          const expandingItems = document.querySelectorAll('.mega-menu.expanding');
          if (!expandingItems.length) {
            document.documentElement.classList.remove('overlay-visible');
          }

          aTiming = setTimeout(() => {
            megaMenuItem.classList.remove('shrinking');
            megaMenuItem.open = false;
            megaMenuItem.querySelector('summary').ariaExpanded = 'false';

            const expandingItems = document.querySelectorAll('.mega-menu.expanding');
            const openItems = document.querySelectorAll('.mega-menu[open]');
            if (!expandingItems.length && !openItems.length) {
              document.documentElement.classList.remove('overlay-visible');
              document.documentElement.classList.remove('overlay-active');
            }
          }, 500);
        } else {
          megaMenuItem.classList.remove('featured-active');
        }
      });

      megaMenuItem.querySelector('summary').addEventListener("click", (event) => {
        if (megaMenuItem.classList.contains('shrinking') || !megaMenuItem.open) {
          clearTimeout(aTiming);
          megaMenuItem.classList.add('expanding');
          megaMenuItem.classList.remove('shrinking');
          document.documentElement.classList.add('overlay-active');
          document.documentElement.classList.add('overlay-visible');
          megaMenuItem.open = true;
          megaMenuItem.querySelector('summary').ariaExpanded = 'true';
          megaMenuItem.classList.remove('expanding');
        } else {
          event.preventDefault();
        }
      });
    });
  }

  /* Mega Menu Level 3 */
  const megaMenuContent = document.querySelectorAll('.mega-menu__content');

  if (megaMenuContent.length) {
    //let winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let lvl1FeaturedParent = document.querySelector('#Details-HeaderMenu-1');
    
    megaMenuContent.forEach((megaMenuContentItem) => {
      const megaMenuLvl2ListItems = megaMenuContentItem.querySelectorAll('.mega-menu__list > li');
      let switchTimeout;

      if (!megaMenuLvl2ListItems.length) {
        return;
      }

      megaMenuLvl2ListItems.forEach((listItem) => {
        const innerContent = listItem.querySelector('.mega-menu__inner-content');
        let switchOutTimeout, switchInTimeout;

        if (!innerContent) {
          return;
        }

        listItem.addEventListener("mouseenter", () => {
          clearTimeout(switchOutTimeout);
          clearTimeout(switchTimeout);

          listItem.parentElement.parentElement.classList.add('active');
          listItem.classList.add('active');

          if (listItem.id != 'HeaderMenu-mega-menu-item-shop-featured' && lvl1FeaturedParent) {
            lvl1FeaturedParent.classList.remove('featured-active');
          }
  
          switchInTimeout = setTimeout(() => {
            listItem.classList.add('visible');
          },200);
        });
        
        listItem.addEventListener("mouseleave", () => {
          clearTimeout(switchInTimeout);
          clearTimeout(switchTimeout);
          
          listItem.classList.remove('visible');

          if (listItem.id == 'HeaderMenu-mega-menu-item-shop-featured' && lvl1FeaturedParent) {
            lvl1FeaturedParent.classList.remove('featured-active');
          }
          
          switchOutTimeout = setTimeout(() => {
            listItem.classList.remove('active');
          },450);

          switchTimeout = setTimeout(() => {
            listItem.parentElement.parentElement.classList.remove('active');
          },600);
        });
      });
    });
  }
  /* /PB */

  } catch(e) { console.error(e); }
})();
})();
